import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Row, Col, Typography, Spin, Input, Button, notification } from 'antd';
import { MuiPickersUtilsProvider, KeyboardTimePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { withTranslation } from 'react-i18next';
import adminI18n from '../../i18n/adminI18n';
import './BookingItemModal.css';

const { Text } = Typography;
const { Search } = Input;

@inject('BookingItemStore')
@observer
class BookingItemModalPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false
        }
    }

    componentDidMount() {
    }

    // ON CHANGE

    // ON Search

    categoryOnSearch = () => {
        this.props.BookingItemStore.setCategorySearchValue('');
        this.props.BookingItemStore.searchCategory();
        this.props.BookingItemStore.setShowBookingCategorySearchModal(true);
    }

    subCategoryOnSearch = () => {
        this.props.BookingItemStore.setSubCategorySearchValue('');
        this.props.BookingItemStore.searchSubCategory();
        this.props.BookingItemStore.setShowBookingSubCategorySearchModal(true);
    }

    // ON CLICK

    createOrUpdateBookingItemDetailOnClick = () => {
        this.props.BookingItemStore.createOrUpdateBookingItemDetail();
    }

    initUpdateBookingItemDetailOnClick = (fnbAdditionalItemDetailId) => {
        this.props.BookingItemStore.initUpdateBookingItemDetail(fnbAdditionalItemDetailId);
    }

    deleteBookingItemDetailOnClick = (fnbAdditionalItemDetailId) => {
        this.props.BookingItemStore.deleteBookingItemDetail(fnbAdditionalItemDetailId);
    }

    createOrUpdateBookingItemOnClick = () => {
        const { t } = this.props;
        const { bookingItemId } = this.props.BookingItemStore;
        if (bookingItemId === 0) {
            this.props.BookingItemStore.createBookingItem().then(response => {
                if (response.isSuccess) {
                    notification['success']({
                        message: t('Success'),
                        description: t('Booking Item has been successfully created.'),
                        duration: 3
                    });
                } else {
                    notification['error']({
                        message: t('Error'),
                        description: `${response.error}`,
                        duration: 3
                    });
                }
            });
        } else {
            this.props.BookingItemStore.updateBookingItem().then(response => {
                if (response.isSuccess) {
                    notification['success']({
                        message: t('Success'),
                        description: t('Booking Item has been successfully updated.'),
                        duration: 3
                    });
                } else {
                    notification['error']({
                        message: t('Error'),
                        description: `${response.error}`,
                        duration: 3
                    });
                }
            });
        }
    }

    render() {
        const { t } = this.props;
        const {
            startTime,
            endTime,
            bookingCategoryName,
            bookingSubCategoryName,
            itemTextButton,
            bookingItemModalLoading,
            bookingSubCategoryFilter
        } = this.props.BookingItemStore;

        let addOrUpdateItemDisable = false;
        if (bookingCategoryName === '' || startTime === '' || endTime === '') {
            addOrUpdateItemDisable = true;
        }

        return (
            <Spin spinning={bookingItemModalLoading}>
                <Row className='bookingitemmodal-row-container'>
                    <Col span={24} className='bookingitemmodal-col'>
                        <Row>
                            <Col span={8} className='bookingitemmodal-col-label'>
                                <Text className='bookingitemmodal-text-label'>{t('Category')}<Text className='bookingitemmodal-text-label-mandatory'>*</Text></Text>
                            </Col>
                            <Col span={16} className='bookingitemmodal-col-input'>
                                <Search
                                    placeholder={t('Search Category')}
                                    value={bookingCategoryName}
                                    onSearch={this.categoryOnSearch}
                                    enterButton
                                />
                            </Col>
                        </Row>
                    </Col>
                    <>
                        {
                            bookingSubCategoryFilter.length > 0
                                ?
                                <>
                                    <Col span={24} className='bookingitemmodal-col'>
                                        <Row>
                                            <Col span={8} className='bookingitemmodal-col-label'>
                                                <Text className='bookingitemmodal-text-label'>{t('Sub Category')}<Text className='bookingitemmodal-text-label-mandatory'>*</Text></Text>
                                            </Col>
                                            <Col span={16} className='bookingitemmodal-col-input'>
                                                <Search
                                                    placeholder={t('Search Sub Category')}
                                                    value={bookingSubCategoryName}
                                                    onSearch={this.subCategoryOnSearch}
                                                    enterButton
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                </>
                                :
                                null
                        }
                    </>
                    <Col span={24} className='bookingitemmodal-col'>
                        <Row>
                            <Col span={8} className='bookingitemmodal-col-label'>
                                <Text className='bookingitemmodal-text-label'>{t('Start Time')}<Text className='bookingitemmodal-text-label-mandatory'>*</Text></Text>
                            </Col>
                            <Col span={16} className='bookingitemmodal-col-picker'>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardTimePicker
                                        margin='dense'
                                        ampm={false}
                                        id='bookingitemstarttime-picker'
                                        style={{ width: '30%', marginRight: 5, marginLeft: 0, top: -12 }}
                                        value={startTime}
                                        onChange={(e) => this.props.BookingItemStore.setStartTime(e)}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change time',
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={24} className='bookingitemmodal-col'>
                        <Row>
                            <Col span={8} className='bookingitemmodal-col-label'>
                                <Text className='bookingitemmodal-text-label'>{t('End Time')}<Text className='bookingitemmodal-text-label-mandatory'>*</Text></Text>
                            </Col>
                            <Col span={16} className='bookingitemmodal-col-picker'>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardTimePicker
                                        margin='dense'
                                        ampm={false}
                                        id='bookingitemendtime-picker'
                                        style={{ width: '30%', marginRight: 5, marginLeft: 0, top: -12 }}
                                        value={endTime}
                                        onChange={(e) => this.props.BookingItemStore.setEndTime(e)}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change time',
                                        }}
                                    />
                                </MuiPickersUtilsProvider>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={24} className='bookingitemmodal-col-button'>
                        <Button disabled={addOrUpdateItemDisable} type='primary' className='bookingitemmodal-button' onClick={this.createOrUpdateBookingItemOnClick}>{t(itemTextButton)}</Button>
                    </Col>
                </Row>
            </Spin >
        )
    }
}

export default withTranslation(undefined, { i18n: adminI18n })(BookingItemModalPage);
